import React from 'react';

import { Section, Grid, Stack } from '@gogame/components';
import { withFormFieldGroupFormField, FormField } from '@gogame/form';

import SizeTextField from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm/SizeTextField';
import { PARTNER } from 'scenes/CustomAudiences/LookalikeAudiences/components/LookalikeAudienceForm/constants';
import { loadCountries } from 'scenes/CustomAudiences/LookalikeAudiences/sources/fields.js';

import {
  COUNTRIES,
  SIZES,
  INCLUDE_INTERNATIONAL,
  GROUP_BY_COUNTRY,
  MULTIPLY_OPTIONS,
} from './constants';

const FormGroup = ({ name: _path }) => {
  return (
    <Section
      title={'Targeting'}
      subTitle={'Top % players of parent audience in the selected countries'}
    >
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <FormField.MultiSelect
            padding={0}
            label={'Countries'}
            withSelectAll={false}
            withFilter={true}
            placeholder={'Select countries'}
            name={COUNTRIES}
            source={loadCountries}
            depends={[PARTNER]}
            helper={
              'Separate Lookalike for each of the selected countries will be created'
            }
            required={true}
          />
        </Grid>
        <Grid item xs={4}>
          <SizeTextField
            padding={0}
            label={'Audience sizes, %'}
            placeholder={'0'}
            name={`${MULTIPLY_OPTIONS}.${SIZES}`}
            helper={'Example: 5, 5-10, 5-20'}
            required={true}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack spacing={0}>
            <FormField.Checkbox
              label={'Allow international'}
              name={`${MULTIPLY_OPTIONS}.${INCLUDE_INTERNATIONAL}`}
              helper={
                'If less then 100 players find the rest in another countries'
              }
              padding={0}
            />
            <FormField.Checkbox
              label={'Group by country'}
              name={`${MULTIPLY_OPTIONS}.${GROUP_BY_COUNTRY}`}
              helper={
                'If less then 100 players find the rest in another countries'
              }
              padding={0}
            />
          </Stack>
        </Grid>
      </Grid>
    </Section>
  );
};

export default withFormFieldGroupFormField({})(FormGroup);
